<template>
  <div class="app-container">
    <CrudTable entity="Country" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['code', 'name']
    };
  }
};
</script>

<style scoped></style>
